import { registerRootComponent } from 'expo';
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { Provider } from 'react-native-paper';
import Amplify from 'aws-amplify';

// import awsconfig from './aws-exports';

import TranslationProvider from './translation/provider';
import useCachedResources from './hooks/cached-resources';
import useColorScheme from './hooks/color-scheme';
import Navigation from './navigation';

Amplify.configure(/* awsconfig */);
Amplify.Logger.LOG_LEVEL = 'INFO';

function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  if (!isLoadingComplete) {
    return null;
  }

  return (
    <Provider>
      <TranslationProvider>
        <Navigation colorScheme={colorScheme} />
        <StatusBar />
      </TranslationProvider>
    </Provider>
  );
}

export default registerRootComponent(App);
